import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { ProposalCopyingForRecalProvider } from "presentation/store/ProposalCopyingForRecal/ProposalCopyingForRecalProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import ProposalCopyingForRecalMaintenance from "presentation/view/section/ProposalCopyingForRecal/ProposalCopyingForRecalMaintenance";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const ProposalCopyingForRecalContMain = () => {
    return <ANAInfoWrapper permission={Permission.PROPOSAL_COPY_FOR_RECAL_MAINTENANCE}>
        <MessageBarWrapper>
            <ProposalCopyingForRecalProvider>
                <GridStyles />
                <ProposalCopyingForRecalMaintenance />
            </ProposalCopyingForRecalProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default ProposalCopyingForRecalContMain;